import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 10.02h5V21h-5V10.02zM17 21h5V10h-5v11zm5-18H3v5h19V3zM3 21h5V10H3v11z"
}), 'TableChartSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TableChartSharp.js
// module id = 6676
// module chunks = 2